import { render } from "./DataInput.vue?vue&type=template&id=3636c2c8&scoped=true"
import script from "./DataInput.vue?vue&type=script&lang=js"
export * from "./DataInput.vue?vue&type=script&lang=js"

import "./DataInput.vue?vue&type=style&index=0&id=3636c2c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3636c2c8"]])

export default __exports__